import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Summary from "../../../components/cases/donations";
import { getUpdatedData } from "../../../redux/slices/AuditTrailSlice";
import { getAssetsOnBoardingList } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { getAssetsDocuments } from "../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import { getAutditTrail } from "../../../services/auditTrails";
import { getAssetsTabDocument } from "../../../services/yourAssets/CommonServices";
import { getClientIdFromLocalStorage } from "../../../utils/Utilities";

const Donations = () => {
  let clientId = getClientIdFromLocalStorage();
  const { id } = useParams();
  const dispatch = useDispatch();
  const reloadAssetsFiles = useSelector(
    (state) => state.assetsDocuments.documents.reload
  );

  const fetchDocumentList = async () => {
    const result = await getAssetsTabDocument(clientId);
    if (result?.success) {
      dispatch(getAssetsDocuments(result.payLoad.items));
    }
  };

  const fetchAuditTrail = async () => {
    const result = await getAutditTrail(id);
    if (result?.success) {
      dispatch(getUpdatedData(result?.payLoad));
    } else {
      dispatch(getUpdatedData([]));
    }
  };

  useEffect(() => {
    fetchAuditTrail();
  }, [window.location.pathname]);

  useEffect(() => {
    fetchDocumentList();
  }, [reloadAssetsFiles]);

  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);

  const updates = useSelector((state) => state.auditTrail.updates);
  return (
    <>
      <Summary updates={updates} />
    </>
  );
};

export default Donations;
